module.exports = __webpack_public_path__ + "bv.88b8b4d2f004c3e94676.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/bv.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/bv.svg
// module chunks = styles